(function($) {
    function patchFetchForAjaxTables() {
        if (window.Taskello?.ajaxTableFetchPatched || typeof window.fetch !== 'function') {
            return;
        }

        const originalFetch = window.fetch.bind(window);

        window.fetch = function (input, init = {}) {
            const body = init?.body;

            if (!(body instanceof FormData) || !body.has('table_action_id')) {
                return originalFetch(input, init);
            }

            const headers = new Headers(init.headers || {});
            headers.set('X-Requested-With', 'XMLHttpRequest');

            return originalFetch(input, {
                ...init,
                headers
            });
        };

        window.Taskello = window.Taskello || {};
        window.Taskello.ajaxTableFetchPatched = true;
    }

    patchFetchForAjaxTables();

    function getFormSnapshot(form) {
        return $(form).serialize();
    }

    function initUnsavedChangesTracking(form) {
        const registry = window.Taskello?.unsavedChanges;

        if (!registry || form.data('taskello-unsaved-tracking')) {
            return null;
        }

        const formElement = form.get(0);
        const formId = form.attr('id') || `form-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
        let savedSnapshot = getFormSnapshot(formElement);

        const tracker = registry.register(formId, formElement, {
            markSaved: () => {
                savedSnapshot = getFormSnapshot(formElement);
            }
        });

        if (!tracker) {
            return null;
        }

        form.data('taskello-unsaved-tracking', tracker);

        form.on('input.taskelloUnsaved change.taskelloUnsaved', ':input', () => {
            tracker.setDirty(getFormSnapshot(formElement) !== savedSnapshot);
        });

        return tracker;
    }

    $.fn.taskelloForm = function () {
        const form = $(this);
        const unsavedTracker = initUnsavedChangesTracking(form);

        $(this).on('submit', async (e) => {
            e.preventDefault();

            const formElement = form.get(0);
            const canSubmit = await window.Taskello?.unsavedChanges
                ?.confirmNavigation?.({ ignoreElement: formElement });

            if (canSubmit === false) {
                return;
            }

            const submitButton = $(this).find(':submit'),
                activeElement = document.activeElement;

            const isMultipart = (form.attr('enctype') || '').toLowerCase() === 'multipart/form-data';
            let formData,
                urlObj = new URL(window.location.href);

            if (isMultipart) {
                formData = new FormData(form[0]);
            } else {
                formData = form.serializeArray();
            }

            window.Taskello.debug.log('Wysłanie formularza', form, formData, urlObj, [activeElement]);

            submitButton.prop('disabled', true);

            if (activeElement && form.has(activeElement).length && $(activeElement).is('[type="submit"]')) {
                if ($(activeElement).attr('name') && $(activeElement).val()) {
                    if (isMultipart) {
                        formData.append($(activeElement).attr('name'), $(activeElement).val());
                    } else {
                        formData.push({
                            name: $(activeElement).attr('name'),
                            value: $(activeElement).val()
                        });
                    }
                }
            }

            if (form.closest('[data-url]').length > 0) {
                urlObj = new URL(window.location.origin + form.closest('[data-url]').attr('data-url'));
            }

            urlObj.searchParams.set('ajax', 'form');

            const ajaxOptions = {
                url: urlObj.toString(),
                type: form.attr('method') || 'POST',
                data: formData,
            };

            if (isMultipart) {
                ajaxOptions.processData = false;
                ajaxOptions.contentType = false;
            }

            $.ajax({
                ...ajaxOptions,
                success: function (response) {
                    window.Taskello.debug.log('Odpowiedz formularza', form, response);

                    const json = window.dynamic.tryParseJson(response);

                    if (json !== null) {
                        window.Taskello?.unsavedChanges?.markFormSaved?.(form.get(0));
                        unsavedTracker?.markSaved?.();
                        window.dynamic.processResponse(json, form);

                        return;
                    }

                    const formId = form.attr('id'),
                        $newForm = $('<div>').html(response).find('#' + formId);

                    if ($newForm.length > 0) {
                        window.Taskello.debug.log('Przeładowanie treści formularza', form, response);

                        $('#' + formId).replaceWith($newForm);
                    } else {
                        window.Taskello?.unsavedChanges?.markFormSaved?.(form.get(0));
                        unsavedTracker?.markSaved?.();

                        let $container = $('#' + formId).closest('[data-modal-body]');
                        $container = $container.length ? $container : $('#content');

                        $container.html(response);
                    }
                }
            });
        });
    };
})(jQuery);
